<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less">
    @import "../common/style/variables";

    .ivu-modal {
        top: 50%!important;
        transform: translateY(-50%)!important;
    }
    .wrapper{
        background-image: url("../common/image/bg.png");
        background-size: cover;
        background-position: center;
        height: 100%;
        overflow: hidden;
        .login-wrapper{
            position: relative;
            width: 550px;
            height: 400px;
            opacity: 0.8;
            background: #FFFFFF;
            box-shadow: 2px 2px 27px -7px #A3B8C4;
            border-radius: 4px;
            margin: 175px auto;
            padding: 21px 0 50px 0 ;
            div:nth-of-type(1){
                width: 100%;
                text-align: center;
                font-family: PingFangSC-Medium;
                font-size: 20px;
                color: #111111;
                letter-spacing: 0;
            }
            div:nth-of-type(2){
                width: 100%;
                text-align: center;
                font-family: PingFangSC-Regular;
                font-size: 20px;
                color: #000000;
                letter-spacing: 0;
                line-height: 28px;
                padding-bottom: 23px;
            }
            img{
                border: 1px solid #CBCACA;
                box-shadow: 2px 2px 4px 0 rgba(221,218,218,0.50);
                width: 250px;
                height: 250px;
                margin: 0 auto;
                display: block;
            }
            .history{
                position: absolute;
                bottom: 23px * @scaleRate;
                right: 23px;
                color: #111111;
                cursor: pointer;
                font-size: 13px;
                color: #4B89F3;
                letter-spacing: 0;
                .arrow{
                    background: url("../common/image/icon_right_blue_arrow.png") no-repeat;
                    background-size: cover;
                    width: 9px;
                    height: 9px;
                    display: inline-block;
                    margin-left: -3px;
                }
            }
        }
    }

</style>
<template>
    <div class="wrapper">
        <div class="login-wrapper" >
            <div>机构入驻申请</div>
            <div>请用微信二维码，添加运营专员申请</div>
            <img src="../common/image/icon_org_apply.jpg"/>
            <div class="history" @click="goBack()">
                <span>返回</span>
                <i class="arrow"></i>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                loginId: '',
                qrCode: 'http://iph.href.lu/250x250',
                socket: null,
                status: ''
            }
        },
        methods: {
            goBack () {
                this.$router ? this.$router.back() : window.history.back()
            },
            getQrCode () {
                this.$ajax.getQrCode().then((res) => {
                    this.qrCode = `data:image/png;base64,${res.data.image}`
                    this.loginId = res.data.loginId
                    this.timer = setInterval(this.getLoginStatus.bind(this), 2000)
                })
            },
            orgLogon () {
                this.$router.push('organizeLogin')
            },
            getLoginStatus () {
                this.$ajax.getLoginStatus({loginId: this.loginId}).then((res) => {
                    let data = res.data
                    if (data.type === 2) {
                        // 用户扫描成功
                        this.status = 'scanSuccess'
                    }
                    if (data.type === 3) {
                        // 登陆成功
                        // 获取token 存到 storage 里面
                        clearInterval(this.timer)
                        if (!this.once) {
                            this.once = true
                            this.status = 'loginSuccess'
                            window.localStorage['token'] = data.data
                            this.getUserInfo()
                        }
                    }
                })
            },
            getUserInfo () {
                this.$store.dispatch('getUserInfo').then((res) => {
                    this.$router.push({
                        path: '/'
                    })
                }, (err) => {
                    console.log('获取用户信息失败')
                })
            }
        },
        mounted () {
            window.localStorage['token'] = ''
//      this.getQrCode()

            // new WxLogin({
            //     id: 'login-wx',
            //     appid: window.wtEnv.login_appid,
            //     scope: 'snsapi_login',
            //     redirect_uri: `${window.wtEnv.serverBaseUrl}/user/wxScanCode`
            // })

            // 判断是否有errMsg
            console.log(this.$route.params)
            let errMsg = this.$route.params.errMsg
            if (errMsg) {
                // 提示错误信息
                this.$Modal.error({
                    title: '登录失败',
                    content: errMsg
                })
            }
        },
        beforeDestroy () {
            clearInterval(this.timer)
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/OrganizeApply.vue